// extracted by mini-css-extract-plugin
export var border = "_1c-8";
export var brand = "_1c-t";
export var button = "_1c-l";
export var center = "_1c-a";
export var centered = "_1c-6";
export var closeButton = "_1c-c";
export var disabledWrapper = "_1c-m";
export var error = "_1c-p";
export var extraLarge = "_1c-4";
export var extraSmall = "_1c-1";
export var fill = "_1c-i";
export var footer = "_1c-h";
export var footerAction = "_1c-j";
export var footerButtons = "_1c-k";
export var header = "_1c-7";
export var headerWithClose = "_1c-d";
export var icon = "_1c-o";
export var info = "_1c-s";
export var inline = "_1c-9";
export var large = "_1c-3";
export var main = "_1c-e";
export var modal = "_1c-0";
export var nearFull = "_1c-5";
export var neutral = "_1c-u";
export var noPadding = "_1c-g";
export var none = "_1c-v";
export var scrollable = "_1c-f";
export var small = "_1c-2";
export var success = "_1c-r";
export var tight = "_1c-n";
export var titleIcon = "_1c-b";
export var warn = "_1c-q";